<div class="warp-tooltip" *ngIf="apiExposureEnabled$()">
  <div class="api-field-name" *ngIf="name">
    <img src="/assets/images/icon-api.png" />
    <span>{{ name }}</span>
  </div>
  <div class="tooltip-abs">
    <p translate>apiExposure.fieldName</p>
  </div>
</div>
